var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"copy-field",on:{"click":_vm.copy}},[_vm._v(" "+_vm._s(_vm.value)+" "),_c('v-icon',{attrs:{"x-small":"","color":"white"}},[_vm._v("mdi-content-copy")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }